import axios from "@/axios-auth";

// CAIXA tariff suggestions (Parâmetros → Cadastros - Produtos e Serviços).
// Every response uses the backend envelope { success, message, data }; errors
// come from axios-auth as { error } (it never rejects), with data.codigo.

const state = {
  tarifasSugestoesPendentes: 0,
};

const mutations = {
  setTarifasSugestoesPendentes: (state, pendentes) => {
    state.tarifasSugestoesPendentes = Number(pendentes) || 0;
  },
};

const getters = {
  tarifasSugestoesPendentes: (state) => state.tarifasSugestoesPendentes,
};

const erroDaResposta = (res) => {
  const body = (res.error ? res.error.response && res.error.response.data : res.data) || {};
  return {
    codigo: (body.data && body.data.codigo) || null,
    mensagem: body.message || "Não foi possível contactar o servidor. Tente novamente.",
  };
};

const actions = {
  // Badge only: any failure just hides the button.
  buscarResumoTarifasSugestoes: async ({ commit }) => {
    const res = await axios.get("/tarifas-sugestoes/resumo");
    const ok = !res.error && res.data && res.data.success !== false;
    const pendentes = ok && res.data.data ? res.data.data.pendentes : 0;

    commit("setTarifasSugestoesPendentes", pendentes);
    return pendentes;
  },
  listarTarifasSugestoes: async ({ commit }) => {
    const res = await axios.get("/tarifas-sugestoes");

    if (res.error || !res.data || res.data.success === false) {
      return { ok: false, ...erroDaResposta(res) };
    }

    const dados = res.data.data || {};
    commit("setTarifasSugestoesPendentes", dados.pendentes);
    return { ok: true, dados };
  },
  confirmarTarifasSugestoes: async ({ commit }, payload) => {
    const res = await axios.post("/tarifas-sugestoes/confirmar", payload);

    if (res.error || !res.data || res.data.success === false) {
      return { ok: false, ...erroDaResposta(res) };
    }

    const dados = res.data.data || {};
    commit("setTarifasSugestoesPendentes", dados.pendentes);
    return {
      ok: true,
      mensagem: res.data.message || "",
      pendentes: Number(dados.pendentes) || 0,
      resultados: dados.resultados || [],
    };
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
